import { render } from "./footer.vue?vue&type=template&id=debfc706&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=debfc706&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-debfc706"

export default script